import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
  selector: 'app-flotante-sirenas',
  templateUrl: './flotante-sirenas.component.html',
  styleUrl: './flotante-sirenas.component.scss',
  standalone: false,
})
export class FlotanteSirenasComponent {
  @Input() sirenasLength?: number;
  @Input() sirenasOnline?: number;
  @Input() sirenasOffline?: number;
  @Output() clusterChange = new EventEmitter<boolean>();
  public clusterEnabled = true;
  constructor() {}

  public onToggleCluster() {
    this.clusterEnabled = !this.clusterEnabled;
    this.clusterChange.emit(this.clusterEnabled);
  }
}
